import React from "react";
import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { useSelector, useDispatch } from "react-redux";
import * as locationActionCreators from "./actions";
import * as orderActionCreators from "../actions";
import _ from "lodash";
import { useState } from "react";
const Locations = () => {
  const selectedLocation = useSelector((storeState) => storeState.setLocation);
  const { load, setLocation } = bindActionCreators(
    locationActionCreators,
    useDispatch()
  );
  const { applyFilter } = bindActionCreators(
    orderActionCreators,
    useDispatch()
  );

  const [previousSelectedLocation, setselectedLocation] = useState();

  useEffect(() => {
    if (!_.isEqual(previousSelectedLocation, selectedLocation)) {
      setselectedLocation(selectedLocation);
    }
  });

  useEffect(() => {
    applyFilter(selectedLocation);
  }, [previousSelectedLocation]);

  useEffect(function () {
    load();
  }, []);

  const locations = useSelector((storeState) => storeState.locations);

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center justify-center text-xs font-semibold">Locations:</div>
      <select
        className="cstm-select focus:outline-none focus:shadow-green-700 focus:shadow-md  text-[0.8rem] block !text-[0.7rem] !block !w-1/4"
        id="inputGroupSelect01"
        onChange={(evt) => setLocation(evt.target.value)}
      >
        <option value="" selected hidden>
          ALL
        </option>
        {locations.map((loactionOption) => (
          <option value={loactionOption.id} key={loactionOption.id}>
            {loactionOption.locationName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Locations;
